import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between" }
const _hoisted_2 = { class: "flex items-center justify-end" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus mr-2" }, null, -1)
const _hoisted_4 = { class: "mt-6" }
const _hoisted_5 = {
  key: 1,
  class: "font-semibold"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_discount_actions = _resolveComponent("discount-actions")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_cheap = _resolveComponent("cheap")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_the_table = _resolveComponent("the-table")!
  const _component_table_scroll_wrapper = _resolveComponent("table-scroll-wrapper")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.actions_state.is_actions_opened)
      ? (_openBlock(), _createBlock(_component_discount_actions, {
          key: 0,
          "is-create": _ctx.actions_state.is_create,
          "is-delete": false,
          loading: _ctx.actions_state.is_actions_loading,
          "initial-value": _ctx.actions_state.initial_value,
          onCancel: _cache[0] || (_cache[0] = ($event: any) => (_ctx.actions_state.is_actions_opened = false)),
          onCreate: _ctx.onDiscountCreate
        }, null, 8, ["is-create", "loading", "initial-value", "onCreate"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_page_title, { title: "Скидки" }),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_the_button, {
          class: "primary small",
          onClick: _ctx.startCreate
        }, {
          default: _withCtx(() => [
            _hoisted_3,
            _createTextVNode(" Добавить скидку ")
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.state.is_failed && !_ctx.state.failure.error_state.is_cancel)
        ? (_openBlock(), _createBlock(_component_failed_fetch, {
            key: 0,
            loading: _ctx.state.is_loading,
            text: "При получении скидок произошла ошибка",
            "error-message": _ctx.state.failure.error_state.message,
            "error-url": _ctx.state.failure.error_state.url,
            "error-status": _ctx.state.failure.error_state.status,
            onRefresh: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadDiscounts(_ctx.state.pagination.current_page)))
          }, null, 8, ["loading", "error-message", "error-url", "error-status"]))
        : (_openBlock(), _createBlock(_component_table_scroll_wrapper, {
            key: 1,
            loading: _ctx.state.is_loading
          }, {
            default: _withCtx(() => [
              _createVNode(_component_the_table, {
                loading: _ctx.state.is_loading,
                columns: _ctx.BillingDiscountsColumns,
                rows: _ctx.state.list,
                pagination: "",
                "pagination-current-page": _ctx.state.pagination.current_page,
                "pagination-limit": _ctx.state.pagination.limit,
                "pagination-total-items": _ctx.state.pagination.total_items,
                "pagination-total-pages": _ctx.state.pagination.total_pages,
                onChangePage: _ctx.loadDiscounts
              }, {
                td: _withCtx(({ column, row }) => [
                  (column.key === 'amount')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (row.unitId === _ctx.DISCOUNT_UNIT_TYPES[0].id)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(row[column.key]) + " ₸ ", 1)
                            ], 64))
                          : _createCommentVNode("", true),
                        (row.unitId === _ctx.DISCOUNT_UNIT_TYPES[1].id)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode(_toDisplayString(row[column.key]) + " % ", 1)
                            ], 64))
                          : _createCommentVNode("", true)
                      ], 64))
                    : (column.key === 'status')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          (_ctx.getExpiredStatus(row.expiredAt) === 'ACTIVE')
                            ? (_openBlock(), _createBlock(_component_cheap, {
                                key: 0,
                                class: "small primary"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Активная скидка ")
                                ]),
                                _: 1
                              }))
                            : (_openBlock(), _createBlock(_component_cheap, {
                                key: 1,
                                class: "small"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Закончилась ")
                                ]),
                                _: 1
                              }))
                        ], 64))
                      : (column.key === 'entityType')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            (row[column.key] === _ctx.DISCOUNT_ENTITY_TYPES[0].id)
                              ? (_openBlock(), _createBlock(_component_router_link, {
                                  key: 0,
                                  target: "_blank",
                                  to: `/billing/calculations/${row.entityId}`,
                                  class: "font-semibold text-blue-500 underline"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" накладную ")
                                  ]),
                                  _: 2
                                }, 1032, ["to"]))
                              : _createCommentVNode("", true),
                            (row[column.key] === _ctx.DISCOUNT_ENTITY_TYPES[1].id)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_5, " компанию (ID: " + _toDisplayString(row.entityId) + ") ", 1))
                              : _createCommentVNode("", true)
                          ], 64))
                        : (column.key === 'expiredAt')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                              _createTextVNode(_toDisplayString(_ctx.normalizeDate(row[column.key])), 1)
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                              _createTextVNode(_toDisplayString(row[column.key]), 1)
                            ], 64))
                ]),
                _: 1
              }, 8, ["loading", "columns", "rows", "pagination-current-page", "pagination-limit", "pagination-total-items", "pagination-total-pages", "onChangePage"])
            ]),
            _: 1
          }, 8, ["loading"]))
    ])
  ]))
}